import axios from 'axios';
// import qs from "qs";
import { Message, } from 'element-ui';

/****** 创建axios实例 ******/
const service = axios.create({
    baseURL: 'https://api.ghomecloud.com',  // api的base_url http://192.168.2.105:8089  https://api.ghomecloud.com
    timeout: 5000,  // 请求超时时间
    // responseType: "json",
    withCredentials: true, // 是否允许带cookie这些
    // headers: {
    // 	"content-type": "application/x-www-form-urlencoded;charset=utf-8"
    // }
});


/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
    // Loading.service({})
    config.method === 'post'
    // ? config.data = qs.stringify({...config.data})
    // : config.params = {...config.params};
    config.headers['Content-Type'] = 'application/json';

    return config;
}, error => {  //请求错误处理
    Message({
        message: error,
        type: 'warning'
    });
    Promise.reject(error)
});


/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
    response => {  //成功请求到数据
        // Loading.service({}).close();
        return response
    },
    error => {  //响应错误处理
        console.log('error');
        console.log(error);
        console.log(JSON.stringify(error));

        let text = JSON.parse(JSON.stringify(error)).response === 404
            ? '404'
            : '网络异常，请重试';
        Message({
            message: text,
            type: 'warning'
        });

        return Promise.reject(error)
    }
);
export default service;